module.exports = __webpack_public_path__ + "img/3dForm3.6b799041.svg";